import { render, staticRenderFns } from "./LazyMessageRender.vue?vue&type=template&id=5ea87ed5"
import script from "./LazyMessageRender.vue?vue&type=script&lang=js"
export * from "./LazyMessageRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports